import { faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate, useParams } from "react-router-dom"
import { ModalContentProps } from "../../types/commonTypes"
import { composeUrl } from "../../utils/utils"
import { SecondChoiseButton } from "../styled/Button.style"
import { Section } from "../styled/Containers.style"
import { IconContainer } from "../styled/Icon.style"
import { ModalConfirmButton } from "../styled/Modal.style"
import { Vspace } from "../styled/Separators.style"
import { TextDefaultSmall } from "../styled/Text.style"
import { EventCommType } from "../../types/communication/communicationDataType"
import { saveCommunicationAct } from "../../store/communication-data/actions"
import { useAppDispatch } from "../../store/hooks"
import { PATHS } from "../../routes/CaiExperienceRouter"

export const CancelConfirmIdentityModalContent = ({ close, additionalData }: ModalContentProps<null>) => {
    const dispatch = useAppDispatch();
    const { token } = useParams();
    const navigate = useNavigate();

    const evVal = additionalData?.event

    const endProcessHandler = () => {
        /* istanbul ignore next */
        const nextPath = composeUrl(token, PATHS.CAI_PAPER)
        /* istanbul ignore next */
        if (evVal) {
            const newEvent = new EventCommType({ value: evVal })
            dispatch(saveCommunicationAct({
                events: [newEvent],
            }))
        }
        // Go in any case to the Cancel path
        navigate(nextPath)
    }

    return (
        <>
            <Section>
                <IconContainer>
                    <FontAwesomeIcon icon={faInfoCircle} />
                </IconContainer>
            </Section>

            <Section>
                <TextDefaultSmall>Questo passaggio è necessario per procedere con la Constatazione Amichevole digitale.<br />In alternativa potrai scattare una foto della tua Constatazione Amichevole in formato cartaceo<br /><br />Vuoi tornare indietro per riprovare?</TextDefaultSmall>
            </Section>

            <Vspace qty={2}></Vspace>

            <Section>
                <ModalConfirmButton onClick={close}>TORNO INDIETRO</ModalConfirmButton>
                <Vspace></Vspace>
                <SecondChoiseButton
                    onClick={endProcessHandler}
                >Procedi con la Constatazione Amichevole Cartacea</SecondChoiseButton>
            </Section>

        </>
    )
}
